import request from "@/api";

export function listDepart(data) {
    return request({
        url: '/api/depart/getDepartList',
        method: 'get',
        params: data
    })
}
export function saveDepart(data) {
    return request({
        url: '/api/depart/saveDepart',
        method: 'post',
        data: data
    })
}

export function deleteDepart(data) {
    return request({
        url: '/api/depart/deleteDepart',
        method: 'post',
        data: data
    })
}
